export default {
  computed: {
    size() {
      // const size = {xs:'x-small',sm:'small',lg:'large',xl:'x-large'}[this.$vuetify.breakpoint.name];
      const size = { xs: 'x-small', sm: 'x-small', md: 'small', lg: '', xl: '' }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {}
    }
  }
}